import React from 'react';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';
import dialogLoader from '../utilities/dialogLoader';
import Loader from '../components/Loader';
import { CcusErrorDialog } from '../components/modals/CcusErrorDialog';
import AuthProvider from '../utilities/authProvider';
import {
  SafetyDiaryConfirmForm,
  SafetyDiaryConfirmFormData,
} from '../components/forms/SafetyDiaryConfirmForm';
import { SafetyDiaryService } from '../services/SafetyDiaries';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { withRouter } from 'react-router-dom';
import _slideLoader from '../utilities/slideLoader';
import {
  getSafetyDiaryDetailPageName,
  canSafetyDiaryRemove,
} from '../utilities/roleUtility';
import SafetyDiariesConstants from '../utilities/safetyDiariesConstants';
import { isNullOrEmpty } from '../utilities/stringUtil';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { ConferencePageHeader } from '../components/PageHeader';
import { ArrowPagingIcon } from '../components/icons/ArrowPagingIcon';
import { messageUtility } from '../utilities/messageUtility';
import Confirmation from '../components/modals/common/Confirmation';
import Information from '../components/modals/common/Information';

const ModalState = {
  closeConfirm: 1,
  withdrawDiary: 2,
  deleteDiary: 3,
  notFound: 4,
};

/**
 * @description 巡回記録詳細
 */
class SafetyDiariesConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: SessionStorageService.getFieldId(),
      userId: LocalStorageService.getUserId(),
      roleId: LocalStorageService.getRoleId(),
      formData: SafetyDiaryConfirmFormData,
      dataId: props.view.state.id !== 0 ? props.view.state.id : null,
      modalState: null,
      prev: null,
      next: null,
      isAllowRemove: false,
      loaded: false,
    };

    this.handleDeleteDiary = this.handleDeleteDiary.bind(this);
    this.handleSelectSafetyDiary = this.handleSelectSafetyDiary.bind(this);
  }

  componentDidMount = () => {
    if (!isNullOrEmpty(this.state.dataId)) {
      this.getSafetyDiary();
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.state.dataId &&
      prevState.dataId !== this.state.dataId &&
      !isNullOrEmpty(this.state.dataId)
    ) {
      this.getSafetyDiary();
    }

    if (prevState.dataId !== this.state.dataId) {
      this.setState({ dataId: this.props.view.state.dataId });
    }

    if (
      this.props.view.state.dataId &&
      prevProps.view.state.dataId !== this.props.view.state.dataId
    ) {
      this.setState({ dataId: this.props.view.state.dataId });
    }
  };

  /**
   * @description 巡回記録情報取得
   */
  getSafetyDiary() {
    const params = this.props.view.state.params || {
      date_type: SafetyDiariesConstants.dataType.entriesDate,
    };
    SafetyDiaryService.getDiary(this.state.fieldId, this.state.dataId, params)
      .then(response => {
        // 編集画面を表示すべきなのに詳細画面を表示された場合は、編集画面へ遷移する。
        // 直リンクで直接遷移した時に上記の可能性がある。
        if (
          SafetyDiariesConstants.pageName.safetyDiariesRegister ===
          getSafetyDiaryDetailPageName(response.data.entities.safety_diary)
        ) {
          this.handleSelectSafetyDiary(
            null,
            response.data.entities.safety_diary
          );
        } else {
          this.setState({
            canRemove: canSafetyDiaryRemove(
              response.data.entities.safety_diary
            ),
            next: response.data.entities.prev,
            prev: response.data.entities.next,
            loaded: true,
          });
        }
      })
      .catch(error => {
        const errorMessage = error.toString();
        if (errorMessage.includes('Network Error')) {
          console.error(
            'request.js requestWithToken',
            'ネットワークエラーです',
            errorMessage
          );
          this.handleCloseSlide();
        }
        switch (error.status) {
          // force logout, if authorization failed.
          case 400: {
            this.handleCloseSlide();
            return false;
          }
          case 401: {
            // エラーメッセージをダイアログに出力後、ログアウト処理を実行
            dialogLoader.show(
              CcusErrorDialog,
              {
                callback: {
                  done: () => {
                    AuthProvider.instance.logout();
                  },
                },
                message:
                  error.data.message || messageUtility.getMessage('E-000-036'),
              },
              null
            );
            return false;
          }
          case 403: {
            this.handleCloseSlide();
            return false;
          }
          case 404: {
            this.setState({ modalState: ModalState.notFound });
            Loader.done();
            return false;
          }
          case 422: {
            this.handleCloseSlide();
            return false;
          }
          case 500: {
            console.error(
              'request.js requestWithToken',
              'ネットワークエラー 500 です',
              JSON.stringify(error)
            );
            window.location.replace('/error-500');
            return false;
          }
          case 503: {
            window.location.replace('/');
            return false;
          }
          default: {
            console.error(
              'request.js requestWithToken',
              'ネットワークエラーです',
              errorMessage
            );
            window.location.replace('/error-500');
            return false;
          }
        }
      });
  }

  handleRegisterRecovery = () => {
    this.handleOpenNewSlide({
      name: 'SafetyDiariesRecoveryRegister',
      state: {
        ...this.props.view.state,
        id: this.state.dataId,
        dataId: this.state.dataId,
      },
    });
  };

  handlePreviewRecovery = () => {
    this.handleOpenNewSlide({
      name: 'SafetyDiariesRecoveryApproval',
      state: {
        id: this.state.dataId,
        dataId: this.state.dataId,
        params: this.props.view.state.params,
      },
    });
  };

  /**
   * @description 巡回記録削除
   */
  handleDeleteDiary = () => {
    SafetyDiaryService.deleteDiary(this.state.fieldId, this.state.dataId).then(
      response => {
        if (response.result === true) {
          this.handleCloseSlide();
        }
      }
    );
  };

  /**
   * 「前へ」「次へ」の押下時の処理
   * ※SafetyDiaries.jsx、SafetyDiariesRegister.jsx、SafetyConfirm.jsxにの同じコードがあるので注意
   *
   * @memberof SafetyDiariesConfirm
   */
  handleSelectSafetyDiary = (event, data) => {
    if (event !== null && event.target.closest('[data-unlink]')) {
      return;
    }

    _slideLoader.show(
      getSafetyDiaryDetailPageName(data),
      {
        state: {
          id: data.id,
          dataId: data.id,
          params: this.props.view.state.params,
        },
      },
      this.props.vw
    );
  };

  handleCloseSlide = () => {
    _slideLoader.close(this.props.vw);
  };

  handleOpenNewSlide = object => {
    _slideLoader.close(this.props.vw);
    _slideLoader.show(
      object.name,
      { state: { ...object.state } },
      this.props.vw
    );
  };

  /**
   * 是正内容系のボタン群
   *
   * @memberof SafetyDiariesConfirm
   */
  renderRecoveryButtons = () => {
    if (!this.state.dataId) {
      return;
    }
    if (this.state.formData.type !== 1) {
      return;
    }

    if (
      this.state.formData.recovery_flag === 1 ||
      this.state.formData.finish_flag === 1
    ) {
      return (
        <button className='btn--stay' onClick={this.handlePreviewRecovery}>
          是正内容を確認する
        </button>
      );
    }

    return (
      <button className='btn--stay' onClick={this.handleRegisterRecovery}>
        是正内容を入力する
      </button>
    );
  };

  handleGoBack = () => {
    this.handleCloseSlide();
  };

  render() {
    const { loaded, prev, next, dataId, canRemove } = this.state;
    return (
      <div className='slide-view show'>
        <Helmet>
          <title>{`${HEADER_CONSTANTS.conference} - 巡回記録詳細`}</title>
        </Helmet>
        <div className='slide-view__view'>
          <ConferencePageHeader
            loaded={loaded}
            loaderComponent={
              <div className='slide-view__title'>
                <ClipLoader size={20} color={'#EDB715'} />
              </div>
            }
            title={<div className='slide-view__title'>巡回記録詳細</div>}
            leftComponent={
              <React.Fragment>
                {/* 削除ボタン */}
                {canRemove && dataId && (
                  <button
                    className='btn--negative'
                    onClick={() =>
                      this.setState({ modalState: ModalState.deleteDiary })
                    }
                  >
                    削除
                  </button>
                )}
                {this.renderRecoveryButtons()}
              </React.Fragment>
            }
            onClose={() => this.handleGoBack()}
          />

          <div className='slide-view__body SafetyDiaries'>
            {(prev || next) && (
              <div className='SafetyDiaries__paging'>
                {prev && (
                  <button
                    className='SafetyDiaries__paging--prev'
                    onClick={event => this.handleSelectSafetyDiary(event, prev)}
                  >
                    <ArrowPagingIcon className='SafetyDiaries__paging-arrow icon--2x' />
                    <span className='SafetyDiaries__paging-text'>前へ</span>
                  </button>
                )}
                {prev && next && (
                  <span className='SafetyDiaries__paging-segment' />
                )}
                {next && (
                  <button
                    className='SafetyDiaries__paging--next'
                    onClick={event => this.handleSelectSafetyDiary(event, next)}
                  >
                    <span className='SafetyDiaries__paging-text'>次へ</span>
                    <ArrowPagingIcon className='SafetyDiaries__paging-arrow icon--2x' />
                  </button>
                )}
              </div>
            )}
            {loaded && (
              <SafetyDiaryConfirmForm
                history={this.props.history}
                dataId={this.state.dataId}
                params={this.props.view.state.params}
                onUpdate={formData => {
                  this.setState({ formData });
                }}
                isSpace={!(next || prev)}
              />
            )}
          </div>
        </div>
        <Confirmation
          visible={this.state.modalState === ModalState.deleteDiary}
          title='巡回記録/各種連絡の削除'
          message={messageUtility.getMessage('I-001-321')}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={this.handleDeleteDiary}
          onCancel={() => this.setState({ modalState: null })}
        />
        <Information
          visible={this.state.modalState === ModalState.notFound}
          title=''
          message={messageUtility.getMessage('E-001-431')}
          buttonText={messageUtility.getMessage('E-001-432')}
          onClose={() => this.handleCloseSlide()}
        />
      </div>
    );
  }
}

export default withRouter(SafetyDiariesConfirm);



// WEBPACK FOOTER //
// ./src/pages/SafetyDiariesConfirm.jsx